import * as Sentry from '@sentry/browser'

export const captureException = async (err: unknown) => {
  Sentry.captureException(err)
}
